import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Markup } from 'interweave';

import { uploadEditorConfig } from '../../services/ckeditor-upload';

import Upload from '../../components/upload';
import { IconEdit, IconDelete } from './icons';

export default class ProjectEdit extends Component {
	state = {
		loadingPage: true,
		company_id: 0,
		project_id: 0,
		project_title: "",
		new_project_title: "",
		company_name: "",
		new_company_name: "",
		company_description: "",
		new_company_description: "",
		logo_src: "",
		new_logo_src: "",
		banner_title: "",
		new_banner_title: "",
		banner_description: "",
		new_banner_description: "",
		banner_src: "",
		new_banner_src: "",
		links: [],
		new_file_id: "",
		new_file_title: "",
		new_file_url: "",
		new_file_description: "",
		modal_logo: "closed",
		modal_banner: "closed",
		modal_delete_banner: "closed",
		modal_description: "closed",
		modal_about: "closed",
		modal_file: "closed",
		modal_delete_file: "closed",
		file_to_delete: "",
		logoField: false,
		bannerField: false,
		titleBannerField: false,
		descriptionBannerField: false,
		aboutField: false,
		companyNameField: false,
		fileTitleField: false,
		fileDescriptionField: false,
		fileUrlField: false,
	}

	componentDidMount() {
		//if page reloads without close any modal
		// document.querySelector('body').classList.remove("no-scroll");
		document.querySelector('body').classList.add("no-scroll");

		const company_id = this.props.match.params.company_id;
		const project_id = this.props.match.params.project_id;
		this.setState({ company_id, project_id });
		this.loadApiProject(company_id, project_id);
	}

	// Config estable: misma referencia en cada render, para que CKEditor no se
	// reinicialice y pierda el cursor mientras se escribe. La compania se lee al
	// subir, no aqui: todavia no ha llegado de los params cuando se construye.
	editorConfig = uploadEditorConfig(() => this.state.company_id);

	// no-scroll vive en el body, que sobrevive a esta pagina. Si se sale mientras
	// carga o con un modal abierto, la clase se queda puesta y la pagina
	// siguiente ya no hace scroll.
	componentWillUnmount() {
		document.querySelector('body').classList.remove("no-scroll");
	}

	// El spinner de los botones tambien es una clase en el DOM, no estado. Cuando
	// solo se quitaba en el camino feliz, un error de la API dejaba el boton
	// girando para siempre; por eso cada handler lo apaga en un finally.
	setButtonLoading = (selector, loading) => {
		const button = document.querySelector(selector);

		if (button) {
			button.classList.toggle("load", loading);
		}
	}

	// Un campo cuenta como relleno si trae texto. Cubre los tres casos que se dan
	// aqui: la cadena vacia, null o undefined cuando el proyecto llega sin ese
	// dato, y la cadena de solo espacios que el usuario teclea en el modal.
	isFilled = (value) => typeof value === "string" && value.trim() !== ""

	loadApiProject = async (company_id, project_id) => {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;

		try {
			const response = await api.get(`companies/${company_id}/projects/${project_id}`);
			const response2 = await api.get(`companies/${company_id}/projects/${project_id}/banner`);
			const response3 = await api.get(`companies/${company_id}/projects/${project_id}/files`);

			this.setState({
				project_title: response.data.title,
				new_project_title: response.data.title,
				company_name: response.data.company_name,
				new_company_name: response.data.company_name,
				company_description: response.data.company_description,
				new_company_description: response.data.company_description,
				banner_title: response2.data.title,
				new_banner_title: response2.data.title,
				banner_description: response2.data.description,
				new_banner_description: response2.data.description,
				links: response3.data,
				loadingPage: false
			});

			if(response.data.logo_url) {
				this.setState({
					logo_src: 'https://seat7-uploads.s3.amazonaws.com/'+response.data.logo_url,
				})
			}

			if(response2.data.image_url) {
				this.setState({
					banner_src: 'https://seat7-uploads.s3.amazonaws.com/'+response2.data.image_url,
				})
			}
		} catch (error) {
			console.log(error);
		} finally {
			// Pase lo que pase hay que soltar la pagina: con el error sin recoger,
			// el velo de carga se quedaba fijo sobre un body bloqueado y no habia
			// forma de salir ni de ver que habia fallado.
			this.setState({loadingPage: false});
			document.querySelector('body').classList.remove("no-scroll");
		}
	}

	modal = (id ,status, file_id) => {
		if(id === "modal_logo")
			this.setState({modal_logo: status})

		if(id === "modal_banner")
			this.setState({modal_banner: status})

		if(id === "modal_description")
			this.setState({modal_description: status})

		if(id === "modal_about"){
			this.setState({modal_about: status})
		}

		if(id === "modal_file"){
			// Al cerrar, el boton de la cabecera no pasa file_id. Antes caia en la
			// rama de edicion, no encontraba ningun link y escribia undefined en los
			// tres campos: React los daba por no controlados, avisaba por consola y
			// el texto tecleado se quedaba dentro del modal cerrado.
			const link = this.state.links.find(item => item.id === file_id);

			this.setState({
				modal_file: status,
				new_file_id: link ? file_id : 0,
				new_file_title: (link && link.title) || "",
				new_file_url: (link && link.file_url) || "",
				new_file_description: (link && link.description) || ""
			})
		}

		if(id === "modal_delete_file"){
			this.setState({
				modal_delete_file: status,
				file_to_delete: file_id
			})
		}

		if(id === "modal_delete_banner") {
			this.setState({
				modal_delete_banner: status
			})
		}

		this.setState({
			logoField: false,
			bannerField: false,
			titleBannerField: false,
			descriptionBannerField: false,
			aboutField: false,
			companyNameField: false,
			fileTitleField: false,
			fileDescriptionField: false,
			fileUrlField: false
		})

		if(status === "opened") {
			document.querySelector('body').classList.add("no-scroll");
		} else {
			document.querySelector('body').classList.remove("no-scroll");
		}
	}

	uploadLogo = (file, file_upload) => {
		this.setState({
			new_logo_src: file,
			logo_file_upload: file_upload
		})
	}

	uploadBanner = (file, file_upload) => {
		this.setState({
			new_banner_src: file,
			banner_file_upload: file_upload
		})
	}

	onChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	saveLogo = async (e) => {
		e.preventDefault();

		const {company_id, project_id, new_logo_src, logo_file_upload} = this.state;
		if(!new_logo_src) {
			this.setState({logoField: true});
		} else {
			this.setState({
				logoField: false
			});

			this.setButtonLoading('.modal-edit-logo .btn-save', true);

			try {
				const form = new FormData();
				form.append('file', logo_file_upload);

				await api.put(`companies/${company_id}/projects/${project_id}/logo/upload`, form);
				this.modal('modal_logo', 'closed');

				this.setState({
					logo_src: new_logo_src,
					new_logo_src: ''
				});
			} catch (error) {
				console.log(error);
			} finally {
				this.setButtonLoading('.modal-edit-logo .btn-save', false);
			}
		}
	}

	saveBanner = async (e) => {
		e.preventDefault();

		const {company_id, project_id, new_banner_src, banner_file_upload} = this.state;
		if(!new_banner_src) {
			this.setState({bannerField: true});
		} else {
			this.setState({
				bannerField: false
			});

			this.setButtonLoading('.modal-edit-banner .btn-save', true);

			try {
				const form = new FormData();
				form.append('file', banner_file_upload);

				await api.put(`companies/${company_id}/projects/${project_id}/banner/upload`, form);

				this.setState({
					banner_src: new_banner_src,
					new_banner_src: ''
				});

				this.modal('modal_banner', 'closed');
			} catch (error) {
				console.log(error);
			} finally {
				this.setButtonLoading('.modal-edit-banner .btn-save', false);
			}
		}
	}

	// El selector lleva la clase del modal concreto. Con '.modal-cancel' a secas
	// cogia el primero de los dos modales de confirmacion de la pagina, asi que
	// borrar un fichero encendia el spinner del boton de borrar el banner.
	hendleDeleteBanner = async () => {
		const { company_id, project_id } = this.state;

		this.setButtonLoading('.modal-delete-banner .btn-delete', true);

		try {
			await api.delete(`companies/${company_id}/projects/${project_id}/banner/file`);

			this.setState({
				banner_src: ""
			});
			this.modal('modal_delete_banner', 'closed');
		} catch (error) {
			console.log(error);
		} finally {
			this.setButtonLoading('.modal-delete-banner .btn-delete', false);
		}
	}

	saveBannerDescription = async (e) => {
		e.preventDefault();
		
		const {company_id, project_id, new_banner_title, new_banner_description} = this.state;

		// Se compara contra vacio, no contra "": un proyecto sin banner llega de la
		// API con title/description a null, y `null === ""` es falso, asi que la
		// validacion dejaba pasar el formulario vacio.
		const missingTitle = !this.isFilled(new_banner_title);
		const missingDescription = !this.isFilled(new_banner_description);

		if(missingTitle || missingDescription) {
			this.setState({
				titleBannerField: missingTitle,
				descriptionBannerField: missingDescription
			})
		} else {
			this.setState({
				titleBannerField: false,
				descriptionBannerField: false
			})

			this.setButtonLoading('.modal-edit-description .btn-save', true);

			try {
				await api.put(`companies/${company_id}/projects/${project_id}/banner_data`, {
					'title': new_banner_title,
					'description': new_banner_description
				});

				// Lo que se ve en la pagina se actualiza despues del PUT. Antes se
				// pintaba primero, asi que un fallo de red dejaba en pantalla un texto
				// que no se habia guardado en ningun sitio.
				this.setState({
					banner_title: new_banner_title,
					banner_description: new_banner_description
				});

				this.modal('modal_description', 'closed');
			} catch (error) {
				console.log(error);
			} finally {
				this.setButtonLoading('.modal-edit-description .btn-save', false);
			}
		}
	}

	saveAboutUs = async (e) => {
		e.preventDefault();
		
		const {company_id, project_id, new_company_name, new_company_description} = this.state;
		const missingName = !this.isFilled(new_company_name);
		const missingDescription = !this.isFilled(new_company_description);

		if(missingName || missingDescription) {
			this.setState({
				aboutField: missingDescription,
				companyNameField: missingName
			})
		} else {
			this.setState({
				aboutField: false,
				companyNameField: false
			})

			this.setButtonLoading('.modal-edit-about .btn-save', true);

			try {
				await api.put(`companies/${company_id}/projects/${project_id}`, {
					'title': this.state.project_title,
					'company_name': new_company_name,
					'company_description': new_company_description,
					'is_template': false
				});

				this.setState({
					company_name: new_company_name,
					company_description: new_company_description
				});

				this.modal('modal_about', 'closed');
			} catch (error) {
				console.log(error);
			} finally {
				this.setButtonLoading('.modal-edit-about .btn-save', false);
			}
		}
	}

	saveFile = async (e) => {
		e.preventDefault();

		const {company_id, project_id, new_file_id, new_file_title, new_file_url, new_file_description} = this.state;

		// Cada campo marca su propio input. Estaban cruzados: faltar la url pintaba
		// de rojo la descripcion y al reves, asi que el aviso senalaba siempre al
		// campo equivocado.
		const missingTitle = !this.isFilled(new_file_title);
		const missingUrl = !this.isFilled(new_file_url);
		const missingDescription = !this.isFilled(new_file_description);

		if(missingTitle || missingUrl || missingDescription) {
			this.setState({
				fileTitleField: missingTitle,
				fileUrlField: missingUrl,
				fileDescriptionField: missingDescription
			})
		} else {
			this.setState({
				fileTitleField: false,
				fileDescriptionField: false,
				fileUrlField: false
			})

			this.setButtonLoading('.modal-edit-files .btn-save', true);

			try {
				// Se mira el principio de la cadena, no si aparece "http" en alguna
				// parte: una url como www.ejemplo.com/http-guide se daba por absoluta y
				// se guardaba sin esquema, y "Http://" en mixto no colaba por ninguno
				// de los dos includes.
				const url = /^https?:\/\//i.test(new_file_url) ? new_file_url : "https://"+new_file_url;

				if(new_file_id === 0) {
					await api.post(`companies/${company_id}/projects/${project_id}/files`,
						{
							"title": new_file_title,
							"file_url": url,
							"description": new_file_description
						}
					);

					// La lista se relee de la API en vez de empujar la fila a mano: el id
					// lo asigna el servidor y sin el, los botones Edit y Delete de la fila
					// recien creada llamaban a .../files/undefined.
					const response = await api.get(`companies/${company_id}/projects/${project_id}/files`);

					this.setState({
						links: response.data
					});
				} else {
					await api.put(`companies/${company_id}/projects/${project_id}/files/${new_file_id}`,
						{
							"title": new_file_title,
							"file_url": url,
							"description": new_file_description
						}
					);

					// Copia nueva de la fila en vez de tocar el objeto que ya esta en el
					// estado. Y la url va en file_url, que es el nombre que usa la API y
					// el que lee el modal: escribirla en fileUrl dejaba la vieja, asi que
					// al reabrir Edit salia la url de antes de guardar.
					this.setState({
						links: this.state.links.map(item => (
							item.id === new_file_id
								? {...item, title: new_file_title, description: new_file_description, file_url: url}
								: item
						))
					});
				}

				this.modal('modal_file', 'closed');
			} catch (error) {
				console.log(error);
			} finally {
				this.setButtonLoading('.modal-edit-files .btn-save', false);
			}
		}
	}

	hendleDeleteFile = async () => {
		const { company_id, project_id, file_to_delete } = this.state;

		this.setButtonLoading('.modal-delete-file .btn-delete', true);

		try {
			await api.delete(`companies/${company_id}/projects/${project_id}/files/${file_to_delete}`);

			// La fila se quita cuando la API confirma. Quitandola antes, un borrado
			// fallido desaparecia de la tabla igual y solo volvia al recargar.
			this.setState({
				links: this.state.links.filter(link => link.id !== file_to_delete)
			});

			this.modal('modal_delete_file', 'closed');
		} catch (error) {
			console.log(error);
		} finally {
			this.setButtonLoading('.modal-delete-file .btn-delete', false);
		}
	}

	render() {
		let logo;
		if(this.state.logo_src) {
			logo = <img src={this.state.logo_src} alt={this.state.company_name}/>
		} else {
			// El hueco del logo no es el logo de nadie: company_name como alt hacia
			// que el lector de pantalla leyera el nombre de la compania sobre una
			// imagen que solo dice "Logo".
			logo = <img src="https://via.placeholder.com/200x60?text=Logo" alt="No logo uploaded yet"/>
		}

		let banner;
		if(this.state.banner_src) {
			banner = <img src={this.state.banner_src} alt={this.state.banner_title}/>
		}

		return (
			<div data-page="landing-page" className="project-edit">
				{/* class en vez de className: React avisaba por consola en cada
					render. Y aria-hidden porque los puntos son decoracion. */}
				<div className={`loading-page ${this.state.loadingPage === true ? 'loading' : ''}`} aria-hidden="true">
					<div className="dots-container">
						<div className="dot"></div>
						<div className="dot"></div>
						<div className="dot"></div>
						<div className="dot"></div>
						<div className="dot"></div>
					</div>
				</div>

				<header className="project-title">
					<div className="container">
						<div className="content">
							<div className="title-container">
								<h1 className="title">{this.state.project_title}</h1>
								<p className="text">This is your project page.<br />Here you can edit the project information before it is sent to publishers</p>
							</div>

							<Link to={`/projects`} className="btn blue-light">Back to projects list</Link>
						</div>
					</div>
				</header>

				<div className="landing-page-header">
					<div className="logo-partner">
						<div className="logo-content">
							{logo}

							{/* Todos estos botones son solo un icono: sin aria-label el lector
								de pantalla los lee como "boton" y no hay forma de saber cual de
								los cuatro lapices de la pagina es cual. */}
							<button type="button" className="edit-button" aria-label="Edit logo" onClick={() => this.modal('modal_logo', 'opened')}>
								<IconEdit />
							</button>
						</div>
					</div>

					<div className={`banner ${!this.state.banner_src ? "empty-banner" : ""}`}>
						<div className="banner-content">
							{banner}

								{ this.state.banner_src &&
									<button type="button" className="edit-button delete-button" aria-label="Delete banner" onClick={() => this.modal('modal_delete_banner', 'opened')}>
										<IconDelete />
									</button>
								}
								{/* Sin banner el boton ya lleva texto dentro, asi que el
									aria-label solo hace falta cuando se queda en icono. */}
								<button type="button" className="edit-button" aria-label={this.state.banner_src ? "Edit banner image" : undefined} onClick={() => this.modal('modal_banner', 'opened')}>
									{ this.state.banner_src &&
										<IconEdit />
									}
									{ !this.state.banner_src &&
										"Insert a banner"
									}
								</button>
						</div>

						<div className="bannner-description">
							<div className="container">
								{/* h2, no un segundo h1: el h1 de la pagina es el titulo del
									proyecto, y con dos el lector de pantalla pierde cual es el
									encabezado principal. Se ve igual porque el tamano lo pone
									.title en landing-page.scss, no la etiqueta. */}
								<h2 className="title">{this.state.banner_title}</h2>
								<div className="text white" data-component="text-editor">
									<Markup content={this.state.banner_description} />
								</div>

								<button type="button" className="edit-button" aria-label="Edit game description" onClick={() => this.modal('modal_description', 'opened')}>
									<IconEdit />
								</button>
							</div>
						</div>
					</div>
				</div>

				<div className="about-us">
					<div className="container">
						<h2 className="title">{this.state.company_name}</h2>
						<div className="text black" data-component="text-editor">
							<Markup content={this.state.company_description} />
						</div>
					</div>

					<button type="button" className="edit-button" aria-label="Edit about us" onClick={() => this.modal('modal_about', 'opened')}>
						<IconEdit />
					</button>
				</div>

				<div className="links-container">
					<div className="container">
						<h3 className="title">Download</h3>

						<div className="links">
							{/* Las columnas de la cabecera copian las de las filas. Llevaban
								3/6/3 y solo a partir de lg: en tablet se quedaban en sm-12, asi
								que "Title" y "Description" salian uno debajo del otro y a lo
								ancho, sin nada que ver con la tabla de abajo. */}
							<div className="link-header">
								<div className="col flex align-center sm-12 md-3 lg-3">
									<p className="title">Title</p>
								</div>
								<div className="col flex align-center sm-12 md-7 lg-7">
									<p className="title">Description</p>
								</div>
								<div className="col flex align-center sm-12 md-2 lg-2"></div>
							</div>

							{this.state.links.map(link => (
								<div className="link-container" key={link.id}>
									<div className="col flex align-center sm-12 md-3 lg-3">
										<div className="link-col"><p className="text">{link.title}</p></div>
									</div>
									<div className="col flex align-center sm-12 md-7 lg-7">
										<div className="link-col"><p className="text">{link.description}</p></div>
									</div>
									<div className="col flex align-center sm-7 md-2 lg-2">
										<div className="link-col action">
											{/* El nombre del fichero va en el aria-label: varias filas
												seguidas de botones que solo dicen "Delete" no se
												distinguen al navegar por la lista de botones. */}
											<button type="button" className="btn" aria-label={`Delete ${link.title}`} onClick={() => this.modal('modal_delete_file', 'opened', link.id)}>Delete</button>

											<button type="button" className="btn" aria-label={`Edit ${link.title}`} onClick={() => this.modal('modal_file', 'opened', link.id)} >Edit</button>
										</div>
									</div>
								</div>
							))}

							<button type="button" className="btn blue add-new-file" onClick={() => this.modal('modal_file', 'opened', 0)} >Add new file</button>
						</div>
					</div>
				</div>

				{/* ------------------------------------------------
					MODAIS -------------------------------------------
				  ---------------------------------------------- */}
				<div data-component="modal" className={`modal-project-edit h-auto ${this.state.modal_logo}`}>
					<div className="modal-container">
						<div className="modal-header">
							<p className="text">Logo</p>
							<button type="button" onClick={() => this.modal('modal_logo', 'closed')} className="btn btn-close" aria-label="Close"></button>
						</div>

						<div className={`modal-content modal-edit-logo ${this.state.logoField ? 'required-image' : ''}`}>
							{ this.state.logoField &&
								<span className="required-field">Insert a new logo</span>
							}
							<Upload title="" id="logoImage" size="500x100" imgPreview={this.state.new_logo_src ? this.state.new_logo_src : ""} handleClick={this.uploadLogo.bind(this)} />

							<div className="filed-infos">
								<div className="text-container">
									<b className="title">Recommended sizes:</b>
									<p className="text">
										Max height: 100px <br/>
										Max width: 500px
									</p>
								</div>
							</div>

							<button type="button" className="btn blue btn-save" onClick={e => this.saveLogo(e)}>Save</button>
						</div>
					</div>
				</div>

				<div data-component="modal" className={`modal-project-edit h-auto ${this.state.modal_banner}`}>
					<div className="modal-container">
						<div className="modal-header">
							<p className="text">Banner</p>
							<button type="button" onClick={() => this.modal('modal_banner', 'closed')} className="btn btn-close" aria-label="Close"></button>
						</div>

						<div className={`modal-content modal-edit-banner ${this.state.bannerField ? 'required-image' : ''}`}>
							{ this.state.bannerField &&
								<span className="required-field">Insert a new banner</span>
							}
							<Upload title="" id="bannerImage" size="1920x650" imgPreview={this.state.new_banner_src ? this.state.new_banner_src : ""} handleClick={this.uploadBanner.bind(this)} />

							<div className="filed-infos">
								<div className="text-container">
									<b className="title">Recommended sizes:</b>
									<p className="text">										
										Width: 1920px <br/>
										Height: 650px
									</p>
								</div>
							</div>

							<button type="button" className="btn blue btn-save" onClick={e => this.saveBanner(e)}>Save</button>
						</div>
					</div>
				</div>

				<div data-component="modal" className={`modal-cancel modal-delete-banner ${this.state.modal_delete_banner}`}>
					<div className="content">
						<p className="text">If you continue you will delete the banner from this project.<br /><b>Are you sure you want to delete this banner?</b></p>
						<button type="button" onClick={() => this.modal('modal_delete_banner', 'closed')} className="btn grey">No</button>
						<button type="button" onClick={() => this.hendleDeleteBanner()} className="btn blue-light btn-delete">Yes</button>
					</div>
				</div>

				<div data-component="modal" className={`modal-project-edit ${this.state.modal_description}`}>
					<div className="modal-container">
						<div className="modal-header">
							<p className="text">About the game</p>
							<button type="button" onClick={() => this.modal('modal_description', 'closed')} className="btn btn-close" aria-label="Close"></button>
						</div>

						<div className={`modal-content modal-edit-description ${this.state.descriptionBannerField ? 'ck-required' : ''}`}>
							<form onSubmit={e => this.saveBannerDescription(e)}>
								<input
									className={`${this.state.titleBannerField ? 'required-input' : ''}`}
									id="new_banner_title"
									name="new_banner_title"
									type="text"
									placeholder="Title"
									value={this.state.new_banner_title}
									onChange={e => this.onChange(e)}
								/>

								{/* El editor cuelga directamente del form a proposito: su alto es
									calc(100% - 154px) sobre el del form, y cualquier nodo en medio
									rompe esa cadena y deja el area de texto sin scroll. El borde
									de campo obligatorio lo pinta .ck-required desde el contenedor
									(el className del propio CKEditor no llega a ningun nodo). */}
								<CKEditor
									editor={ ClassicEditor }
									config={this.editorConfig}
									data={this.state.new_banner_description}
									onChange={ ( event, editor ) => {
										this.setState({new_banner_description: editor.getData()});
									}}
								/>
								{/* <textarea
									className={`${this.state.descriptionBannerField ? 'required-input' : ''}`}
									id="new_banner_description"
									name="new_banner_description"
									type="text"
									placeholder="Description"
									value={this.state.new_banner_description}
									onChange={e => this.onChange(e)}
								></textarea> */}

								<button type="submit" className="btn blue btn-save">Save</button>
							</form>
						</div>
					</div>
				</div>

				<div data-component="modal" className={`modal-project-edit ${this.state.modal_about}`}>
					<div className="modal-container">
						<div className="modal-header">
							<p className="text">About us</p>
							<button type="button" onClick={() => this.modal('modal_about', 'closed')} className="btn btn-close" aria-label="Close"></button>
						</div>

						<div className={`modal-content modal-edit-about ${this.state.aboutField ? 'ck-required' : ''}`}>
							<form onSubmit={e => this.saveAboutUs(e)}>
								<input
									className={`${this.state.companyNameField ? 'required-input' : ''}`}
									id="new_company_name"
									name="new_company_name"
									type="text"
									placeholder={this.state.company_name}
									value={this.state.new_company_name}
									onChange={e => this.onChange(e)}
								/>

								<CKEditor
									editor={ ClassicEditor }
									config={this.editorConfig}
									data={this.state.new_company_description}
									onChange={ ( event, editor ) => {
										this.setState({new_company_description: editor.getData()});
									}}
								/>
								{/* <textarea
									className={`${this.state.aboutField ? 'required-input' : ''}`}
									id="new_company_description"
									name="new_company_description"
									type="text"
									placeholder="Company description"
									value={this.state.new_company_description}
									onChange={e => this.onChange(e)}
								></textarea> */}

								<button type="submit" className="btn blue btn-save">Save</button>
							</form>
						</div>
					</div>
				</div>

				<div data-component="modal" className={`modal-project-edit h-auto ${this.state.modal_file}`}>
					<div className="modal-container">
						<div className="modal-header">
							<p className="text">File</p>
							<button type="button" onClick={() => this.modal('modal_file', 'closed')} className="btn btn-close" aria-label="Close"></button>
						</div>

						<div className="modal-content modal-edit-files">
							<form onSubmit={e => this.saveFile(e)}>
								<input
									className={`${this.state.fileTitleField ? 'required-input' : ''}`}
									autoComplete="off"
									name="new_file_title"
									type="text"
									placeholder="File name"
									value={this.state.new_file_title}
									onChange={e => this.onChange(e)}
								/>
								<input
									className={`${this.state.fileDescriptionField ? 'required-input' : ''}`}
									autoComplete="off"
									name="new_file_description"
									type="text"
									placeholder="Short description"
									value={this.state.new_file_description}
									onChange={e => this.onChange(e)}
								/>
								<input
									className={`${this.state.fileUrlField ? 'required-input' : ''}`}
									autoComplete="off"
									name="new_file_url"
									type="text"
									placeholder="url"
									value={this.state.new_file_url}
									onChange={e => this.onChange(e)}
								/>

								<button type="submit" className="btn blue btn-save">Save</button>
							</form>
						</div>
					</div>
				</div>

				<div data-component="modal" className={`modal-cancel modal-delete-file ${this.state.modal_delete_file}`}>
					<div className="content">
						<p className="text">If you continue you will delete all information contained in this item.<br /><b>Are you sure you want to delete this item?</b></p>
						<button type="button" onClick={() => this.modal('modal_delete_file', 'closed')} className="btn grey">No</button>
						<button type="button" onClick={() => this.hendleDeleteFile()} className="btn blue-light btn-delete">Yes</button>
					</div>
				</div>

				<footer className="preview-page">
					<div className="container">
						<Link to={`/projects`} className="btn blue-light">Back to projects list</Link>
					</div>
				</footer>
			</div>
		)
	};
}